import { Pipe, PipeTransform } from "@angular/core";
import { SearchColumn } from "../../search-utils";

@Pipe({
  name: "visibleCols"
})
export class VisibleColumnsPipe implements PipeTransform {
  transform(filters: SearchColumn[]): any {
    return filters.filter(item => item.Hidden == false);
  }
}
